import Immutable from 'immutable'
import * as USER_ACTION from '../constants/types/userTypes'
import * as PUSH_ACTION from '../constants/types/pushTypes'
import {stateStructure} from './_stateStructure.js'
import {setCookie, delCookie} from '../helpers/unit';
import { MENUS } from '../constants/menus/reportMenus'

const initialState = Immutable.fromJS( stateStructure.user );

export default function user( state = initialState, action ){

	let _state = state.toJS();

	switch (action.type) {
		// 登录&获取个人信息
		case USER_ACTION.LOGIN:{
			setCookie('auth', action.result.data.token);
			setCookie(action.result.data.cookie.cookie_name, action.result.data.cookie.sessid, action.result.data.cookie.expires_in);
			// 保存账号密码
			if (action.extend.saveUser) {
				$.setCookie('_username', action.extend.username, 60*60*24*30*12);
				$.setCookie('_password', action.extend.password, 60*60*24*30*12);
			}else{
				$.delCookie('_username');
				$.delCookie('_password');
			}
			return state;
		}
		case USER_ACTION.GET_USERINFO:{
			_state.info = action.result.data;
			_state.balance.lottery = action.result.data.availablebalance;
			window.userId = _state.info.userid;
			return state.merge(_state);
		}
		// 获取用户菜单
		case USER_ACTION.GET_USER_MENUS:{
			let allMenus = _.cloneDeep(MENUS)
			_.each(allMenus, function(category){
				_.each(category.menus, function(menu){
					// 没有ID，那么就直接通过
					if (!menu.id && !menu.children) {return true}
					if (menu.id) {
						const remoteMenu = _.find(action.result.data, {id: String(menu.id)});
						// 没有权限
						if (!remoteMenu && !menu.children) {
							menu.disabled = true;
							return true;
						}
						// 有权限
						if (!menu.children) {
							menu.uri = remoteMenu.uri;
							return true;
						}
					}
					if (menu.children) {
						_.each(menu.children, function(childMenu){
							if (!childMenu.id) {return true}
							const remoteChildMenu = _.find(action.result.data, {id: String(childMenu.id)});
							// 没有权限
							if (!remoteChildMenu) {
								childMenu.disabled = true;
								return true;
							}
							// 有权限
							childMenu.uri = remoteChildMenu.uri;
						})
						const actived = _.filter(menu.children, {disabled: true});
						if (actived && actived.length == menu.children.length) {
							menu.disabled = true;
						}
					}
				})
			})
			// 帮助菜单
			const helperMenus = _.chain(action.result.data)
								.filter((item) => _.includes(item.uri, '/help/'))
								.filter((item) => !_.includes(item.name, '主框架'))
								.filter((item) => !_.includes(item.name, '查看公告'))
								.filter((item) => !_.includes(item.name, '公告列表'))
								.map((item) => _.merge(item, {url: 'help' + item.uri.split('/help')[1]}))
								.value()
			allMenus.push({
				type: 'help',
				name: '疑问解答',
				className: 'default',
				menus: helperMenus
			})
			_state.menus = allMenus;
			return state.merge(_state);
		}
		// 获取用户最近投注信息
		case USER_ACTION.GET_USER_BET_RECENT:{
			_state.recentBet = action.result.data;
			return state.merge(_state);
		}
		// 清空用户最近投注信息
		case USER_ACTION.CLEAR_USER_BET_RECENT:{
			_state.recentBet = null;
			return state.merge(_state);
		}
		// 使用新版TOKEN换取旧版SESSION
		case USER_ACTION.GET_SESSION_BY_TOKEN:{
			const {cookie_name, sessid, expires_in} = action.result.data;
			setCookie(cookie_name, sessid, expires_in);
			_state.sessid = sessid;
			return state.merge(_state);
		}
		// 使用旧版SESSION换取新版TOKEN
		case USER_ACTION.GET_TOKEN_BY_SESSION:{
			window.AUTH_TOKEN = action.result.data.token;
			setCookie('auth', action.result.data.token);
			return state;
		}
		// 同步用户余额
		case PUSH_ACTION.LIVE_USER_BALANCE:{
			_state.info.availablebalance = action.money;
			_state.balance.lottery = action.money;
			return state.merge(_state);
		}
		// 获取未读聊天条数
		case USER_ACTION.GET_UNREAD_CHAT_COUNT:{
			_state.chat.count = action.result.data.count;
			return state.merge(_state);
		}
		// 同步未读聊天条数
		case PUSH_ACTION.LIVE_UNREAD_CHAT_COUNT:{
			_state.chat.count = action.count
			return state.merge(_state);
		}
		// 从平台获取余额
		case USER_ACTION.GET_BALANCE_FROM_PLATFORM:{
			// 如果是彩票余额，那么更新user.info中的余额值
			if (action.extend == 'lottery') {
				_state.info.availablebalance = action.result.data.balance;
			}
			_state.balance[action.extend] = action.result.data.balance;
			// 如果获取到了余额，那么平台可用
			_state.platform_profile[action.extend].available = true;
			_state.platform_profile[action.extend].code = null;
			_state.platform_profile[action.extend].message = null;
			_state.platform_profile[action.extend].onload = true;
			return state.merge(_state)
		}
		// 获取彩票余额
		case USER_ACTION.GET_BALANCE_FOR_LOTTERY:{
			_state.balance['lottery'] = action.result.data.balance;
			_state.info.availablebalance = action.result.data.balance;
			return state.merge(_state)
		}
		// 获取平台用户信息
		case USER_ACTION.GET_PLATFORM_PROFILE:{
			_state.platform_profile[action.extend].userInfo = action.result.data;
			return state.merge(_state)
		}
		// 标记用户平台不可用
		case USER_ACTION.MARK_PLATFORM_UNAVAILBLE:{
			// 没有加入过游戏平台
			if (action.status == 30301) {
				_state.platform_profile[action.platform].available = false;
			}
			_state.platform_profile[action.platform].code = action.code;
			_state.platform_profile[action.platform].message = action.message;
			_state.platform_profile[action.platform].onload = true;
			return state.merge(_state)
		}
		// 修改密码
		case USER_ACTION.CHANGE_PASSWORD:{
			window.STORE.changePasswordToken = null;
			return state.merge(_state)
		}
		// 创建平台账号
		case USER_ACTION.CREATE_PLATFORM_ACCOUNT:{
			_state.platform_profile[action.extend].available = true;
			_state.platform_profile[action.extend].code = null;
			_state.platform_profile[action.extend].message = null;
			return state.merge(_state)
		}
		// 同步未读站内信数
		case PUSH_ACTION.LIVE_UNREAD_NOTICE_COUNT:{
			_state.info.messages = action.count;
			return state.merge(_state)
		}
		// 用户注册
		case USER_ACTION.REGISTER:{
			return state;
		}
		// 注册开户
		case USER_ACTION.REGISTER_BY_AGENT:{
			location.href = '#/my';
			return state;
		}
		// 注销用户
		case USER_ACTION.LOGOUT:{
			delCookie('_sessionHandler');
			delCookie('auth')
			window.AUTH_TOKEN = null;
   			window.AUTH_EXPIRESIN = null;
			_state = _.cloneDeep(initialState).toJS()
			_state.sessid = null;
			return Immutable.fromJS( _state )
		}

		case USER_ACTION.LEGAL_WITHDRAW_TYPE: {
			_state.withdraw_type_data = action.result.data;
			return state.merge(_state);
		}

		default:
      		return state;
	}
}
